import { StyleSheet, Text, View } from '@react-pdf/renderer'

import CarBodyDetails from './CarBodyDetails'
import IconCheck from './IconCheck'
import IconClose from './IconClose'

const styles = StyleSheet.create({
  heading: {
    fontSize: 14,
    fontWeight: 700,
    marginBottom: 4
  },
  container: {
    margin: '32px 24px 0',
    gap: 24,
    fontSize: 8,
    fontWeight: 500
  },
  section: {
    flexDirection: 'row',
    gap: 20
  },
  divider: {
    height: 0.5,
    backgroundColor: '#E2E6EB',
    marginVertical: 8
  },
  half: {
    width: '100%'
  },
  gap: {
    gap: 11
  },
  bold: { fontWeight: 600 },
  row: {
    flexDirection: 'row'
  },
  alignCenter: { alignItems: 'center' },
  centered: {
    justifyContent: 'center',
    alignItems: 'center'
  }
})

const CarInfo = ({ techState, selectedCar = {} }) => {
  const { marka, model, year, vin } = selectedCar
  return (
    <View style={styles.container}>
      <View style={styles.section}>
        <View style={[styles.half, styles.centered]}>
          <CarBodyDetails
            carBodySchemeWidth={264}
            carBodySchemeHeight={320}
            inspectionExternalPurch={techState.inspectionExternalPurch}
          />
        </View>

        <View style={styles.half}>
          <View style={{ marginBottom: 30 }}>
            <Text style={styles.heading}>
              {marka} {model} {year}
            </Text>
            <Text>{vin}</Text>
          </View>

          <View style={styles.gap}>
            <View style={styles.gap}>
              <View style={[styles.row, styles.alignCenter]}>
                <IconCheck />
                <Text>
                  — заводской окрас детали / бөлшектің түпнұсқалық түсі
                </Text>
              </View>
              <View style={styles.row}>
                <IconClose />
                <Text>
                  — вторичный или более окрас / следы кузовного ремонта екінші
                  реттік немесе одан да көп бояу / көлік кузовындағы жөндеу
                  іздері
                </Text>
              </View>
            </View>

            <View style={styles.divider} />

            <View style={styles.gap}>
              <Text>
                <Text style={styles.bold}>Суреттегі цифрлар</Text>— микронмен
                (мкр) көрсетілген лак-бояу жабынының (ЛБЖ) қалыңдығы
              </Text>
              <Text>
                <Text style={styles.bold}>80 ден 200 ге дейінгі мән</Text>—
                әдетте түпнұсқа түсі болып табылады
              </Text>
              <Text>
                <Text style={styles.bold}>200-ден 500-ге дейінгі мә</Text>—
                косметикалық бояудың немесе қорғаныш пленкасының жапсырылғанын
                көрсетеді
              </Text>
              <Text>
                <Text style={styles.bold}>500-ден 1000-ға дейінгі мән</Text>—
                шпаклевка қолданылған бояудың болуын білдіреді
              </Text>
            </View>

            <View style={styles.divider} />

            <View style={styles.gap}>
              <Text>
                <Text style={styles.bold}>Цифры на изображении</Text>— толщина
                лакокрасочного покрытия (ЛКП) в микронах (мкр)
              </Text>
              <Text>
                <Text style={styles.bold}>от 80 до 200</Text>— обычно является
                заводским окрасом
              </Text>
              <Text>
                <Text style={styles.bold}>от 200 до 500</Text>— наличие
                косметического окраса или наклеенной защитной пленки
              </Text>
              <Text>
                <Text style={styles.bold}>от 500 до 1000</Text>— наличие окраса
                с применением шпаклевки
              </Text>
            </View>
          </View>
        </View>
      </View>
      <View style={styles.section}>
        <Text style={styles.half}>
          *Көрсетілген 1000 мкр мәні стандартты құралдың максималды диапазонына
          сәйкес келеді, алайда одан жоғары мәндердің болуы мүмкін.
        </Text>
        <Text style={styles.half}>
          *Указанное значение 1000 мкр соответствует максимальному диапазону
          стандартного прибора, однако допускается превышение и отображение
          значений выше.
        </Text>
      </View>
    </View>
  )
}

export default CarInfo
